module.exports = __webpack_public_path__ + "static/mobileDevice-67be078dbb4e2f5c1ab6b2a57b706f89.png";